// DashLite header height: $logo-height(36) + 14px*2 gap + 1px border — see docs/pms-design-system.md
export const HEADER_HEIGHT = 65;

// Must match .pms-project-sidebar / .is-collapsed widths in
// sidebar/project-sidebar.css — plain CSS has no build-time sharing, so the
// two sides are kept in step by comment. Intentionally px and NOT font-scaled:
// see the mechanism note in src/theme/fontScale.tsx.
export const PROJECT_SIDEBAR_WIDTH = 255;
export const PROJECT_SIDEBAR_COLLAPSED_WIDTH = 72;
